import { z } from 'zod';

import { EmergencyContactRelation } from '@/common/graphql';

export const EmergencyContactRelationLabels: Record<EmergencyContactRelation, string> = {
  [EmergencyContactRelation.Mother]: 'Mother',
  [EmergencyContactRelation.Father]: 'Father',
  [EmergencyContactRelation.Wife]: 'Wife',
  [EmergencyContactRelation.Husband]: 'Husband',
  [EmergencyContactRelation.Brother]: 'Brother',
  [EmergencyContactRelation.Sister]: 'Sister',
  [EmergencyContactRelation.Other]: 'Others',
};

export const EmployeeEmergencyContact = z.object({
  id: z.string().default(''),
  name: z.string().default(''),
  relation: z.nativeEnum(EmergencyContactRelation).default(EmergencyContactRelation.Other),
  phoneNumberCountryCode: z.string().default(''),
  phoneNumberCountryIsdCode: z.string().nullable().default(null),
  phoneNumber: z.string().default(''),
  remarks: z.string().nullable().default(null),
});
export type EmergencyContactType = z.infer<typeof EmployeeEmergencyContact>;
